import React from "react";

class Footer extends React.Component {
  render() {
    return (
      <div>
        <div
          data-elementor-type="footer"
          data-elementor-id="5015"
          className="elementor elementor-5015 elementor-location-footer"
          id="footer-0531"
        >
          <div className="elementor-section-wrap">
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-d956126 elementor-section-boxed elementor-section-height-default elementor-section-height-default exad-glass-effect-no exad-sticky-section-no"
              data-id="d956126"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-60b5c49 exad-glass-effect-no exad-sticky-section-no"
                  data-id="60b5c49"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <section
                      className="elementor-section elementor-inner-section elementor-element elementor-element-905b974 elementor-section-boxed elementor-section-height-default elementor-section-height-default exad-glass-effect-no exad-sticky-section-no"
                      data-id="905b974"
                      data-element_type="section"
                      data-settings='{"background_background":"classic"}'
                    >
                      <div className="elementor-container elementor-column-gap-default">
                        <div
                          className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-e3e9369 exad-glass-effect-no exad-sticky-section-no"
                          data-id="e3e9369"
                          data-element_type="column"
                        >
                          <div className="elementor-widget-wrap elementor-element-populated" style={{fontSize: '19px', fontWeight: 500}}>
                            <div
                              className="elementor-element elementor-element-343e928 de_scroll_animation_no exad-sticky-section-no exad-glass-effect-no elementor-widget elementor-widget-text-editor"
                              data-id="343e928"
                              data-element_type="widget"
                              data-widget_type="text-editor.default"
                            >
                              <div className="elementor-widget-container">
                                <div
                                  className="elementor-element elementor-element-a9c6f8f de_scroll_animation_no elementor-widget elementor-widget-heading"
                                  data-id="a9c6f8f"
                                  data-element_type="widget"
                                  data-widget_type="heading.default"
                                >
                                  <div className="elementor-widget-container">
                                    <p className="elementor-heading-title elementor-size-default">
                                      <strong>
                                        <span style={{ color: "#000000" }}>
                                          Contatos
                                        </span>
                                      </strong>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-3303c1c elementor-icon-list--layout-traditional elementor-list-item-link-full_width de_scroll_animation_no exad-sticky-section-no exad-glass-effect-no elementor-widget elementor-widget-icon-list"
                              data-id="3303c1c"
                              data-element_type="widget"
                              data-widget_type="icon-list.default"
                            >
                              <div className="elementor-widget-container">
                                <ul className="elementor-icon-list-items">
                                  <li className="elementor-icon-list-item">
                                    <span className="elementor-icon-list-icon">
                                      <svg
                                        aria-hidden="true"
                                        className="e-font-icon-svg e-far-envelope"
                                        viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"></path>
                                      </svg>
                                    </span>
                                    <span className="elementor-icon-list-text">
                                      contato@sigmobi.com
                                    </span>
                                  </li>
                                  <li className="elementor-icon-list-item">
                                    <span className="elementor-icon-list-icon">
                                      <svg
                                        aria-hidden="true"
                                        className="e-font-icon-svg e-fas-map-marker-alt"
                                        viewBox="0 0 384 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"></path>
                                      </svg>
                                    </span>
                                    <span className="elementor-icon-list-text">
                                      Av. Diário de notícias n°400 sala 708
                                      Cristal Porto Alegre
                                      RS&nbsp;CEP&nbsp;90810-080
                                    </span>
                                  </li>
                                  <li className="elementor-icon-list-item">
                                    <span className="elementor-icon-list-icon">
                                      <svg
                                        aria-hidden="true"
                                        className="e-font-icon-svg e-fas-city"
                                        viewBox="0 0 640 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"></path>
                                      </svg>
                                    </span>
                                    <span className="elementor-icon-list-text">
                                      Sig Mobi Tecnologia - CNPJ
                                      45.670.457/0001-41
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-afcb195 exad-glass-effect-no exad-sticky-section-no"
                          data-id="afcb195"
                          data-element_type="column"
                        >
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div
                              className="elementor-element elementor-element-447887b de_scroll_animation_no exad-sticky-section-no exad-glass-effect-no elementor-widget elementor-widget-image"
                              data-id="447887b"
                              data-element_type="widget"
                              data-widget_type="image.default" style={{display:'flex', alignItems: 'center', justifyContent:'center'}}
                            >
                              <div className="elementor-widget-container" style={{maxWidth: '30vh'}}>
                                <picture  >
                                  <source
                                    srcSet="
                              https://sigmobi.com/wp-content/webp-express/webp-images/uploads/2024/08/Imagem_do_WhatsApp_de_2024-08-26_a_s__13.05.05_53afbfe4-removebg-preview-e1724851685489.png.webp         500w,
                              https://sigmobi.com/wp-content/webp-express/webp-images/uploads/2024/08/Imagem_do_WhatsApp_de_2024-08-26_a_s__13.05.05_53afbfe4-removebg-preview-e1724851685489-300x185.png.webp 300w
                            "
                                    sizes="(max-width: 500px) 100vw, 500px"
                                    type="image/webp"
                                  />
                                  <img
                                    data-lazyloaded="1"
                                    src="https://sigmobi.com/wp-content/uploads/2024/08/Imagem_do_WhatsApp_de_2024-08-26_a_s__13.05.05_53afbfe4-removebg-preview-e1724851685489.png"
                                    width="500"
                                    height="309"
                                    data-src="https://sigmobi.com/wp-content/uploads/2024/08/Imagem_do_WhatsApp_de_2024-08-26_a_s__13.05.05_53afbfe4-removebg-preview-e1724851685489.png"
                                    className="attachment-full size-full wp-image-4981 webpexpress-processed entered litespeed-loaded"
                                    alt=""
                                    data-srcSet="https://sigmobi.com/wp-content/uploads/2024/08/Imagem_do_WhatsApp_de_2024-08-26_a_s__13.05.05_53afbfe4-removebg-preview-e1724851685489.png 500w, https://sigmobi.com/wp-content/uploads/2024/08/Imagem_do_WhatsApp_de_2024-08-26_a_s__13.05.05_53afbfe4-removebg-preview-e1724851685489-300x185.png 300w"
                                    data-sizes="(max-width: 500px) 100vw, 500px"
                                    data-ll-status="loaded"
                                    sizes="(max-width: 500px) 100vw, 500px"
                                    srcSet="
                              https://sigmobi.com/wp-content/uploads/2024/08/Imagem_do_WhatsApp_de_2024-08-26_a_s__13.05.05_53afbfe4-removebg-preview-e1724851685489.png         500w,
                              https://sigmobi.com/wp-content/uploads/2024/08/Imagem_do_WhatsApp_de_2024-08-26_a_s__13.05.05_53afbfe4-removebg-preview-e1724851685489-300x185.png 300w
                            "
                                  />
                                </picture>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-c68a9fd elementor-section-boxed elementor-section-height-default elementor-section-height-default exad-glass-effect-no exad-sticky-section-no"
              data-id="c68a9fd"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2844e18 exad-glass-effect-no exad-sticky-section-no"
                  data-id="2844e18"
                  data-element_type="column"
                >
               <div className="elementor-widget-wrap elementor-element-populated">
  <div
    className="elementor-element elementor-element-74d61b3 elementor-hidden-desktop elementor-hidden-tablet de_scroll_animation_no exad-sticky-section-no exad-glass-effect-no elementor-widget elementor-widget-text-editor"
    data-id="74d61b3"
    data-element_type="widget"
    data-widget_type="text-editor.default" style={{marginBottom: '0px'}}
  >
    <div className="elementor-widget-container" style={{marginBottom: '0px'}}>
      <p  style={{marginBottom: '0px'}}>
        <span style={{verticalAlign: 'inherit'}}
          ><span style={{verticalAlign: 'inherit'}}
            >© 2024 SIG MOBI TECNOLOGIA. Todos os direitos reservados.
          </span></span>
        
        <span style={{verticalAlign: 'inherit'}}
          ><span style={{verticalAlign: 'inherit'}}
            >A SIG MOBI TECNOLOGIA não se responsabiliza pela divulgação de
            informações não oficiais feitas por terceiros.</span
          ></span>
        
      </p>
    </div>
  </div>
  <div
    className="elementor-element elementor-element-7088f05 elementor-hidden-mobile de_scroll_animation_no exad-sticky-section-no exad-glass-effect-no elementor-widget elementor-widget-text-editor"
    data-id="7088f05"
    data-element_type="widget"
    data-widget_type="text-editor.default" style={{marginBottom: '0px'}}
  >
    <div className="elementor-widget-container" style={{marginBottom: '0px'}}>
      <p style={{marginBottom: '0px'}}>
        © 2024 SIG MOBI TECNOLOGIA. Todos os direitos reservados. A SIG MOBI
        TECNOLOGIA não se responsabiliza pela divulgação de informações não
        oficiais feitas por terceiros.
      </p>
    </div>
  </div>
  <div
    className="elementor-element elementor-element-1da7563 de_scroll_animation_no exad-sticky-section-no exad-glass-effect-no elementor-widget elementor-widget-text-editor"
    data-id="1da7563"
    data-element_type="widget"
    data-widget_type="text-editor.default"
  >
    <div className="elementor-widget-container">
      <p>
        Comprometemo-nos a cumprir integralmente a LGPD (Lei Geral de Proteção
        de Dados – Lei n° 13.709, de 14 de agosto de 2018), garantindo a
        privacidade e segurança das informações dos nossos clientes.
      </p>
    </div>
  </div>
  <div
    className="elementor-element elementor-element-5ae4a29 elementor-nav-menu__align-justify elementor-nav-menu--dropdown-none de_scroll_animation_no exad-sticky-section-no exad-glass-effect-no elementor-widget elementor-widget-nav-menu"
    data-id="5ae4a29"
    data-element_type="widget"
    data-settings='{"layout":"horizontal","submenu_icon":{"value":"<svg className=\"e-font-icon-svg e-fas-caret-down\" viewBox=\"0 0 320 512\" xmlns=\"http:\/\/www.w3.org\/2000\/svg\"><path d=\"M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z\"><\/path><\/svg>","library":"fa-solid"}}'
    data-widget_type="nav-menu.default"
  >
    <div className="elementor-widget-container">
  
      <nav
        className="elementor-nav-menu--dropdown elementor-nav-menu__container"
        aria-hidden="true"
      >
        <ul
          id="menu-2-5ae4a29"
          className="elementor-nav-menu"
          data-smartmenus-id="17368045098170254" style={{display: 'flex', justifyContent: 'space-around', listStyleType: 'none'}}
        >
          <li
            className="menu-item menu-item-type-post_type menu-item-object-page menu-item-privacy-policy menu-item-5009"
          >
            <a
              rel="privacy-policy"
              href="https://sigmobi.com/politica-de-privacidade/"
              className="elementor-item"
              tabIndex="-1" style={{color: '#7a7a7a'}}
              >Política de privacidade &amp; Cookies</a
            >
          </li>
          <li
            className="menu-item menu-item-type-post_type menu-item-object-page menu-item-5010"
          >
            <a
              href="https://sigmobi.com/informacoes-de-uso/"
              className="elementor-item"
              tabIndex="-1" style={{color: '#7a7a7a'}}
              >Termos de Uso</a
            >
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>

                </div>
              </div>
            </section>
            <br/> <br/>
            
          </div>
        </div>

        <script
          src="../../assets/js/hello-frontend.min.js"
          id="hello-theme-frontend-js"
        />
        <script
          src="../../assets/js/webpack.runtime.min.js"
          id="elementor-webpack-runtime-js"
        />
        {/* <script
          src="https://cdn.sigmobi.com/assets/js/jquery/jquery.min.js?ver=3.7.1"
          id="jquery-core-js"
        /> */}
        {/* <script
          src="https://cdn.sigmobi.com/assets/js/jquery/jquery-migrate.min.js?ver=3.4.1"
          id="jquery-migrate-js"
        /> */}
        {/* <script
          src="https://cdn.sigmobi.com/assets/assets/js/frontend-modules.min.js?ver=3.25.10"
          id="elementor-frontend-modules-js"
        /> */}
        {/* <script
          src="https://cdn.sigmobi.com/assets/js/jquery/ui/core.min.js?ver=1.13.3"
          id="jquery-ui-core-js"
        /> */}
        <script
          id="elementor-frontend-js-before"
          src="../../assets/js/lazyload.js"
        />
        <script
          type="text/javascript"
          src="../../assets/js/elementor-frontend-js-before.js"
        />
        <script
          src="../../assets/js/frontend.min.js?ver=3.25.10"
          id="elementor-frontend-js"
        />
      </div>
    );
  }
}

export default Footer;
